import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/tabbar/xb.png';
import _imports_1 from '../../assets/image/errorr.png';
const _withScopeId = n => (_pushScopeId("data-v-6aaa5374"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_2 = [_hoisted_1];
const _hoisted_3 = {
  class: "tk-color-tabs"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "图库目录", -1));
const _hoisted_5 = {
  class: "color-tabs"
};
const _hoisted_6 = {
  class: "tk-image-year",
  ref: "scrollYear"
};
const _hoisted_7 = {
  class: "tk-year"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "tk-mian"
};
const _hoisted_10 = {
  class: "tk-image"
};
const _hoisted_11 = {
  class: "tk-img-wrapper",
  ref: "wrapper"
};
const _hoisted_12 = {
  class: "j_wrapper"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "name"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "name"
};
import { onBeforeMount, reactive } from "vue";
import { years, pictureCate } from "@/utils/https/page";
import loadingTips from "@/components/mode/loading";
import { Waterfall } from "@/utils/Waterfall";
import { useStore } from "vuex";
import { lottery_years_color } from "@/utils/https/page";

import { useRouter } from 'vue-router';
import { toRefs, ref, onDeactivated, onActivated } from 'vue';
export default {
  __name: 'image',
  setup(__props) {
    const $store = useStore(); //获取vuex
    const router = useRouter();
    let getImg = () => {
      new Waterfall({
        el: "j_wrapper",
        //父div
        colmun: 2,
        //几列
        gap: 10 //间隙
      });
    };

    let errorload = () => {
      new Waterfall({
        el: "j_wrapper",
        //父div
        colmun: 2,
        //几列
        gap: 10 //间隙
      });
    };

    let data = reactive({
      yearList: [],
      page: 1,
      year: localStorage.getItem("yearone"),
      color: 1,
      pictureData: [],
      websiteName: JSON.parse(localStorage.getItem("config")) == null ? {} : JSON.parse(localStorage.getItem("config")),
      https: process.env.VUE_APP_BASE_API_S,
      acitveIndexLottery: 5,
      hei: [],
      bai: [],
      activeIndex: 1,
      picturex: []
    });
    let {
      yearList,
      pictureData,
      websiteName,
      https,
      acitveIndexLottery,
      activeIndex
    } = toRefs(data);
    onBeforeMount(() => {
      data.acitveIndexLottery = localStorage.getItem("lotteryType") == null ? "2" : localStorage.getItem("lotteryType");
      let picture = JSON.parse(localStorage.getItem("pictureData")) == null ? [] : JSON.parse(localStorage.getItem("pictureData"));
      picture.forEach((item, index) => {
        if (item.expires < Date.now()) {
          data.pictureData.length = 0;
          picture = [];
          localStorage.removeItem("pictureData");
        }
        if (item.lottery == localStorage.getItem("lotteryType")) {
          data.pictureData.push(...item.data);
        } else {
          loading.value = false;
        }
      });
      var date = new Date();
      var yearss = date.getFullYear();
      // if(localStorage.getItem('yearColor')==null || yearss=='2024'){
      //     year();
      // }else{
      //    let year =  JSON.parse(sessionStorage.getItem('lotteryYears'));
      //     year.forEach(element => {
      //         if(element.lotteryType == data.acitveIndexLottery){
      //             element.list.forEach(item => {
      //                 if(item.color==2){
      //                     data.hei.push(item)
      //                 }
      //                 if(item.color==1){
      //                     data.bai.push(item)
      //                 }
      //             })
      //         }
      //     });
      //     data.yearList = data.bai;
      // }
    });

    let yearsColos = async acitveIndexLottery => {
      //获取年份

      data.yearList.length = 0;
      // if ( sessionStorage.getItem('lotteryYears') == null) {
      let ress = await lottery_years_color();
      let lotteryYears = ress.data.data;
      sessionStorage.setItem("lotteryYears", JSON.stringify(lotteryYears));
      lotteryYears.forEach(item => {
        if (item.lotteryType == acitveIndexLottery) {
          data.yearList.push(...item.list);
        }
      });
    };
    // let year = async()=>{//获取年份
    //     let res = await years();
    //     let c = res.data.data;
    //     localStorage.setItem('yearColor',JSON.stringify(c))
    //     let year =  JSON.parse(localStorage.getItem('yearColor'));
    //     c.forEach(element => {
    //         if(element.color==2){
    //             data.hei.push(element)
    //         }

    //         if(element.color==1){
    //             data.bai.push(element)
    //         }
    //     });
    //     data.yearList = data.bai;

    // }

    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const onLoad = () => {
      picture(data.year, data.color, data.page, data.acitveIndexLottery);
      data.page++;
    };
    const onRefresh = () => {
      localStorage.removeItem("lotteryNumber");

      // 清空列表数据
      data.page = 1;
      data.pictureData.length = 0;
      finished.value = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      loading.value = true;
      onLoad();
    };
    let picture = (year, color, page, lottery) => {
      //图片请求

      if (page == 1) {
        loadingTips();
      }
      pictureCate({
        year: year,
        color: color,
        page: page,
        lotteryType: lottery
      }).then(res => {
        if (page == 1) {
          loadingTips("close");
        }
        if (res.data.status == 20000) {
          let datas = res.data.data.data;
          refreshing.value = false;
          if (datas.length == 0) {
            finished.value = false;
          } else {
            loading.value = false;
            data.pictureData.push(...datas);
            data.picturex.push({
              lottery,
              expires: Date.now() + 1000 * 60 * 60,
              data: [...data.pictureData]
            });
            let dd = arrayUnique(data.picturex, "lottery");
            localStorage.setItem("pictureData", JSON.stringify(dd));
            new Waterfall({
              el: "j_wrapper",
              //父div
              colmun: 2,
              //几列
              gap: 10 //间隙
            });
          }
        }
      });
    };

    let arrayUnique = (arr, name) => {
      let hash = {};
      return arr.reduce((acc, cru, index) => {
        if (!hash[cru[name]]) {
          hash[cru[name]] = {
            index: acc.length
          };
          acc.push(cru);
        } else {
          acc.splice(hash[cru[name]]["index"], 1, cru);
        }
        return acc;
      }, []);
    };
    let pictureJump = item => {
      if (item.is_ad) {
        window.location.href = item.ad_url;
      } else {
        localStorage.setItem("comment", true);
        router.push({
          path: `/gallery`,
          query: {
            color: item.color,
            year: item.year,
            id: item.pictureTypeId,
            title: item.pictureName,
            image: data.acitveIndexLottery == 2 ? item.s3_pictureUrl : item.pictureUrl,
            pictureId: item.pictureId,
            lottery: data.acitveIndexLottery,
            s3_pictureUrl: item.s3_prefix_pictureUrl
          }
        });
      }
    };
    let handleTabColor = index => {
      data.activeIndex = index;
      data.page = 1;
      data.color = index;
      data.pictureData.length = 0;
      picture(data.year, index, data.page, data.acitveIndexLottery);
      if (index == 1) {
        data.yearList = data.bai;
      } else {
        data.yearList = data.hei;
      }
    };
    let yearColor = item => {
      router.push({
        path: "/serach",
        query: item
      });
    };
    let majorMore = () => {
      router.push({
        path: `/serach`
      });
    };
    onDeactivated(() => {
      $store.commit("handleImgs", false);
    });
    onActivated(async () => {
      let discoverys = $store.state.imagesb;
      if (discoverys) {
        data.page = 1;
        data.acitveIndexLottery = localStorage.getItem("lotteryType") == null ? "2" : localStorage.getItem("lotteryType");
        data.pictureData.length = 0;
        await yearsColos(data.acitveIndexLottery);
        loading.value = true;
        finished.value = false;
        onLoad();
        let year = JSON.parse(sessionStorage.getItem("lotteryYears"));
        data.hei.length = 0;
        data.bai.length = 0;
        year.forEach(element => {
          if (element.lotteryType == data.acitveIndexLottery) {
            element.list.forEach(item => {
              if (item.color == 2) {
                data.hei.push(item);
              }
              if (item.color == 1) {
                data.bai.push(item);
              }
            });
          }
        });
        data.yearList = data.bai;
      }
    });
    return (_ctx, _cache) => {
      const _component_headNav = _resolveComponent("headNav");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      const _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_headNav, {
        title: "六合图库"
      }, {
        iocn: _withCtx(() => [_createElementVNode("div", {
          class: "icon-tk",
          onClick: _cache[0] || (_cache[0] = (...args) => _unref(majorMore) && _unref(majorMore)(...args))
        }, _hoisted_2)]),
        tkCont: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("ul", null, [_createElementVNode("li", {
          class: _normalizeClass(_unref(activeIndex) == 1 ? 'active' : ''),
          onClick: _cache[1] || (_cache[1] = $event => _unref(handleTabColor)(1))
        }, " 彩色 ", 2), _createElementVNode("li", {
          class: _normalizeClass(_unref(activeIndex) == 2 ? 'active' : ''),
          onClick: _cache[2] || (_cache[2] = $event => _unref(handleTabColor)(2))
        }, " 黑白 ", 2)])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearList), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(item.color == 1 ? 'tk-year-item' : 'tk-year-item color'),
            key: index,
            onClick: $event => _unref(yearColor)(item)
          }, _toDisplayString(item.name), 11, _hoisted_8);
        }), 128))])], 512)]),
        _: 1
      }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_pull_refresh, {
        modelValue: _unref(refreshing),
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _isRef(refreshing) ? refreshing.value = $event : null),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [_createVNode(_component_van_list, {
          loading: _unref(loading),
          "onUpdate:loading": _cache[20] || (_cache[20] = $event => _isRef(loading) ? loading.value = $event : null),
          finished: _unref(finished),
          "finished-text": "没有更多了",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pictureData), (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "item",
              key: index
            }, [item.is_ad ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "card wrapper",
              onClick: $event => _unref(pictureJump)(item)
            }, [_withDirectives((_openBlock(), _createBlock(_component_van_image, {
              style: {},
              src: item.ad_image,
              onLoad: _cache[3] || (_cache[3] = $event => _unref(getImg)())
            }, {
              error: _withCtx(() => [_createElementVNode("img", {
                src: _unref(https) + _unref(websiteName).notfind_image,
                alt: ""
              }, null, 8, _hoisted_14)]),
              _: 2
            }, 1032, ["src"])), [[_directive_lazy, item.ad_image]]), _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1)], 8, _hoisted_13)) : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "card wrapper",
              onClick: $event => _unref(pictureJump)(item)
            }, [_withDirectives((_openBlock(), _createBlock(_component_van_image, {
              src: item.pictureUrl,
              onLoad: _cache[18] || (_cache[18] = $event => _unref(getImg)()),
              onError: _cache[19] || (_cache[19] = $event => _unref(errorload)())
            }, {
              error: _withCtx(() => [_unref(acitveIndexLottery) == 5 ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                key: 0,
                src: item.pictureUrlOther,
                onLoad: _cache[8] || (_cache[8] = $event => _unref(getImg)()),
                onError: _cache[9] || (_cache[9] = $event => _unref(errorload)())
              }, {
                error: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_van_image, {
                  src: item.previousPictureUrl,
                  onLoad: _cache[6] || (_cache[6] = $event => _unref(getImg)()),
                  onError: _cache[7] || (_cache[7] = $event => _unref(errorload)())
                }, {
                  error: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_van_image, {
                    src: item.previousPictureUrlOther,
                    onLoad: _cache[4] || (_cache[4] = $event => _unref(getImg)()),
                    onError: _cache[5] || (_cache[5] = $event => _unref(errorload)())
                  }, {
                    error: _withCtx(() => [_hoisted_17]),
                    _: 2
                  }, 1032, ["src"])), [[_directive_lazy, item.previousPictureUrl]])]),
                  _: 2
                }, 1032, ["src"])), [[_directive_lazy, item.previousPictureUrl]])]),
                _: 2
              }, 1032, ["src"])), [[_directive_lazy, item.pictureUrlOther]]) : _unref(acitveIndexLottery) == 2 ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                key: 1,
                src: item.s3_pictureUrl,
                onLoad: _cache[14] || (_cache[14] = $event => _unref(getImg)()),
                onError: _cache[15] || (_cache[15] = $event => _unref(errorload)())
              }, {
                error: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_van_image, {
                  src: item.s3_prefix_pictureUrl,
                  onLoad: _cache[12] || (_cache[12] = $event => _unref(getImg)()),
                  onError: _cache[13] || (_cache[13] = $event => _unref(errorload)())
                }, {
                  error: _withCtx(() => [_withDirectives(_createVNode(_component_van_image, {
                    src: item.previousPictureUrl,
                    onLoad: _cache[10] || (_cache[10] = $event => _unref(getImg)()),
                    onError: _cache[11] || (_cache[11] = $event => _unref(errorload)())
                  }, null, 8, ["src"]), [[_directive_lazy, item.previousPictureUrl]])]),
                  _: 2
                }, 1032, ["src"])), [[_directive_lazy, item.s3_prefix_pictureUrl]])]),
                _: 2
              }, 1032, ["src"])), [[_directive_lazy, item.s3_pictureUrl]]) : _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                key: 2,
                src: item.previousPictureUrl,
                onLoad: _cache[16] || (_cache[16] = $event => _unref(getImg)()),
                onError: _cache[17] || (_cache[17] = $event => _unref(errorload)())
              }, {
                error: _withCtx(() => [_createElementVNode("img", {
                  src: _unref(https) + _unref(websiteName).notfind_image,
                  alt: ""
                }, null, 8, _hoisted_18)]),
                _: 2
              }, 1032, ["src"])), [[_directive_lazy, item.pictureUrlOther]])]),
              _: 2
            }, 1032, ["src"])), [[_directive_lazy, item.pictureUrl]]), _createElementVNode("div", _hoisted_19, _toDisplayString(item.pictureName), 1)], 8, _hoisted_16))]);
          }), 128))])], 512)])]),
          _: 1
        }, 8, ["loading", "finished"])]),
        _: 1
      }, 8, ["modelValue"])])], 64);
    };
  }
};